import React from 'react';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { ImagemLinkStyled, LinkUnidadeStyled, TituloLinkStyled } from './nps-link-unidade.component.style';
// Imagem e link extra que o Admin permite cadastrar na unidade. Só aparece quando há imagem ou título cadastrado.
export var NpsLinkUnidade = function (_a) {
    var imagem = _a.imagem, titulo = _a.titulo, url = _a.url;
    if (!imagem && !titulo)
        return null;
    var conteudo = (React.createElement(React.Fragment, null,
        imagem && React.createElement(ImagemLinkStyled, { src: imagem, alt: titulo ? '' : 'Imagem da unidade' }),
        titulo && React.createElement(TituloLinkStyled, null, titulo),
        url && React.createElement(BsBoxArrowUpRight, { size: 16, "aria-hidden": "true" })));
    // Sem URL cadastrada o bloco é só informativo, como na tela anterior.
    if (!url)
        return React.createElement(LinkUnidadeStyled, { as: "div" }, conteudo);
    // O ícone de nova aba é decorativo; o aviso vai no nome do link, que começa pelo título visível.
    var nomeLink = (titulo || 'Abrir link da unidade') + " (abre em nova aba)";
    return (React.createElement(LinkUnidadeStyled, { href: url, target: "_blank", rel: "noopener noreferrer", "aria-label": nomeLink }, conteudo));
};
